/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgFluentTeamsFilled = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M14.25 7h-2.69L10 7.65v3.2c0 1.19 1.12 2.15 2.5 2.15s2.5-.96 2.5-2.15v-3.2c0-.36-.34-.65-.75-.65ZM13 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.35 15h.31C10.5 15 12 13.5 12 11.65V7.61c0-.34-.27-.61-.61-.61H5.61c-.34 0-.61.27-.61.61v4.04C5 13.5 6.5 15 8.35 15ZM8.5 6a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ React.createElement("path", {
        opacity: 0.5,
        d: "M8.5 6c.54 0 1.04-.17 1.45-.47A.817.817 0 0 0 9.18 5H6.51c.46.6 1.17 1 1.99 1ZM5.61 7c-.34 0-.61.27-.61.61v4.04c0 .48.1.93.29 1.35h3.08c.9 0 1.63-.72 1.63-1.6V7H5.61Z",
        fill: "#000"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.2 12H1.8c-.44 0-.8-.36-.8-.8V4.8c0-.44.36-.8.8-.8h6.4c.44 0 .8.36.8.8v6.4c0 .44-.36.8-.8.8Z",
        fill: "#4B53BC"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.69 6.25H4.94v4.38h-.88V6.25H2.31v-.87h4.38v.87Z",
        fill: "#fff"
    }));
export default SvgFluentTeamsFilled;
